import moment from 'moment';


export function formatDate(dateToFormat, withTime = false) {

    if (dateToFormat === null || !dateToFormat) {
        return '-';
    }

    const date = moment(dateToFormat).local();

    if (!withTime) {
        return date.format('DD.MM.YYYY');
    }

    return moment(dateToFormat).local().format('DD.MM.YYYY HH:mm');
}

//keep in sync with CONSULTATION_JOIN_WINDOW_BEFORE / _AFTER in the backend config:
//the server only hands out the meeting link inside this window
export const CONSULTATION_JOIN_WINDOW_BEFORE_MINUTES = 15;
export const CONSULTATION_JOIN_WINDOW_AFTER_MINUTES = 120;

/**
 * True while the "join call" button should be offered for a consultation.
 * The server is the authority - it withholds the link outside the window - this only
 * decides whether the button is worth showing.
 */
export function consultationJoinWindowIsOpen(consultation) {

    if (!consultation || !consultation.dateTime) {
        return false;
    }

    const start = moment(consultation.dateTime);
    const now = moment();

    return now.isSameOrAfter(start.clone().subtract(CONSULTATION_JOIN_WINDOW_BEFORE_MINUTES, 'minutes')) &&
        now.isSameOrBefore(start.clone().add(CONSULTATION_JOIN_WINDOW_AFTER_MINUTES, 'minutes'));
}

/**
 * A consultation can be cancelled by either party while it is still more than
 * 24 hours away. Mirrors CONSULTATION_CANCELLATION_NOTICE on the server, which now
 * enforces the same rule rather than trusting the interface.
 */
export function consultationCanBeCancelled(consultation) {

    if (!consultation || !consultation.dateTime) {
        return false;
    }

    if (consultation.status !== 'scheduled' && consultation.status !== 'awaiting_approval') {
        return false;
    }

    return moment().isBefore(moment(consultation.dateTime).subtract(24, 'hours'));
}

/**
 * A request can only be accepted while its start time is still ahead.
 * Nothing ages unanswered requests out, so old ones stay in the dashboard for ever;
 * accepting one would schedule a consultation in the past and the automatic closing
 * would then bill the patient for something that never happened.
 */
export function consultationCanStillBeAccepted(consultation) {

    if (!consultation || !consultation.dateTime) {
        return false;
    }

    return moment().isBefore(moment(consultation.dateTime));
}

/**
 * The psychologist can confirm a consultation took place from its scheduled start until
 * it is closed - after which the platform stops asking.
 */
export function consultationCanBeCompleted(consultation) {

    if (!consultation || !consultation.dateTime) {
        return false;
    }

    if (consultation.status !== 'scheduled' && consultation.status !== 'active') {
        return false;
    }

    return moment().isSameOrAfter(moment(consultation.dateTime));
}

/**
 * Sends a Google Analytics conversion event.
 *
 * gtag is defined by the inline bootstrap in public/index.html, so it is normally there - but
 * this runs inside the registration, payment and booking success handlers, and a throw in one
 * of those would stop the user ever seeing the success screen. Tracking is never worth that.
 */
export function trackEvent(action, label, category = 'User') {

    try {
        if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
            window.gtag('event', action, {
                event_category: category,
                event_label: label
            });
        }
    } catch (e) {
        // analytics must never break the flow it is measuring
    }
}

export function formatNumber(number, round=false) {

    if (number === undefined || number === null) {
        return '0';
    }

    if (round) {
        number = (Math.round(parseFloat(number) * 100) / 100).toFixed(2);
    }

    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}